import React from 'react';
import { Card, CardContent } from './ui/card';
import {
  Home,
  MapPin,
  House,
  Building,
  Briefcase,
  Clock,
  Armchair,
  DollarSign,
  Star,
  Heart,
  Package,
  Warehouse
} from 'lucide-react';
import { mockServices } from '../data/mock';

const iconMap = {
  'home': Home,
  'map-pin': MapPin,
  'house': House,
  'building': Building,
  'briefcase': Briefcase,
  'clock': Clock,
  'armchair': Armchair,
  'dollar-sign': DollarSign,
  'star': Star,
  'heart': Heart,
  'package': Package,
  'warehouse': Warehouse
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Moving Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From local moves to cross-country relocations, we provide professional moving services tailored to your
            unique needs.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockServices.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="hover:shadow-lg transition-shadow duration-300 border border-gray-200 bg-white"
              >
                <CardContent className="p-6">
                  <Icon className="h-12 w-12 text-brand-blue mb-4" />
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;